module.exports = __webpack_public_path__ + "static/media/duplicate.52066965.svg";